import {
  Badge, IconButton, Tooltip, Typography,
} from '@mui/material';

function CustomIcon(props) {
  const {
    Icon,
    label,
    tooltip,
    onClick,
    iconSize,
    size = 'medium',
    hidden,
    disabled,
    badge,
    padding,
    margin,
    variant,
    className,
    sxProps,
    color = 'primary',
  } = props;

  if (hidden) {
    return null;
  }

  const IconComponent = (
    <Icon fontSize={iconSize || size} />
  );

  const BadgeIconComponent = (
    <Badge color="secondary" variant="dot">
      {IconComponent}
    </Badge>
  );

  return (
    <Tooltip title={tooltip} className={className}>
      <IconButton
        size={size}
        disabled={disabled ?? false}
        color={color}
        onClick={onClick}
        sx={(theme) => ({
          ...sxProps,
          p: padding && padding,
          m: margin && margin,
          // cursor: onClick ? 'pointer' : 'default',
          ...(variant === 'contained' && { backgroundColor: 'primary.background' }),
          ...(variant === 'outlined' && {
            border: `1px solid ${theme.palette.primary.border}`,
            color: theme.palette.primary.text,
            '&:hover': {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.primary.lighter,
              borderColor: theme.palette.primary.lighter,
            },
          }),
        })}
      >
        {badge ? BadgeIconComponent : IconComponent}
        {label && (
        <Typography variant="button" sx={{ fontSize: '0.75rem', ml: '4px' }}>
          {label}
        </Typography>
        )}
      </IconButton>
    </Tooltip>
  );
}

export default CustomIcon;
